import RecuperarPanel from './RecuperarPanel';
export default RecuperarPanel;
